import useSWR from "swr";
import { getLoginStatus } from "../api/account";

export const useUserStatus = () => {
  const { data, error, isLoading, mutate } = useSWR(
    "/account/status",
    getLoginStatus,
  );

  if (error) return { status: "error", error, mutate } as const;
  if (!data) return { status: "loading", error, mutate } as const;
  if (data && data.data.status === "unauthenticated") {
    return { status: "unauthenticated", loginId: "", error, mutate } as const;
  }

  const statusOk = !error && !isLoading && data;
  const loginId = statusOk ? data.data.login_id : "";

  return {
    status: "ok",
    loginId,
    data,
    mutate,
  } as const;
};
